import { c as _c } from "react/compiler-runtime";
import noop from 'lodash/noop';
import { useCallback, useEffect, useState } from 'react';
const useContainerHasScroll = containerId => {
  const $ = _c(6);
  const [hasScroll, setHasScroll] = useState(false);
  let t0;
  if ($[0] !== containerId) {
    t0 = () => {
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
      setHasScroll(container.scrollTop > 0);
    };
    $[0] = containerId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleScroll = t0;
  let t1;
  let t2;
  if ($[2] !== containerId || $[3] !== handleScroll) {
    t1 = () => {
      handleScroll();
      const container_0 = document.getElementById(containerId);
      if (!container_0) {
        return noop;
      }
      container_0.addEventListener("scroll", handleScroll);
      return () => {
        container_0.removeEventListener("scroll", handleScroll);
      };
    };
    t2 = [containerId, handleScroll];
    $[2] = containerId;
    $[3] = handleScroll;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return hasScroll;
};
export default useContainerHasScroll;